import MenuTop from "../../../components/menu/top/menu-top";
import Form from "../../../components/form/form";
import storage from "../../../shared/services/storage";
import InfoComponent from "../../../components/info/info";
import { useCallback, useEffect, useState } from "react";
import { fetchSearchersListService } from "../../../features/user/service/user-service";
import { fetchFinanciersService } from "../../../features/financial/service/financiador-service";
import { fetchUserCompanyService, fetchCompaniesService as getCompanies } from "../../../features/company/service/company";
import { createProjectService } from "../../../features/project/service/project-service";
import { useNavigate } from "react-router-dom";
import { projectData } from "../../../features/project/forms/project-data";
import { useAlert } from "../../../components/alert/alert";
import { SEVERITY } from "../../../shared/interfaces/alert";
import { Project } from "../../../shared/interfaces/project";
import { FormProps, FormTypes } from "../../../shared/interfaces/form";
import { Company } from "../../../shared/interfaces/user";
import { FieldRule } from "../../../shared/hooks/useFieldRule";
import './style.css';

function ProjectAdd() {
    const navigate = useNavigate();
    const { showAlert } = useAlert();
    const [ formData, setFormData ] = useState<FormProps[] | any>();
    const [ formSections, setFormSections ] = useState<any[]>();
    const [ companyId, setCompanyId ] = useState<string>();
    const [ company, setCompany ] = useState<Company>();
    const [ isLoading, setIsLoading ] = useState<boolean>(true);
    const [ isSubmitting, setIsSubmitting ] = useState<boolean>(false);

    // Define regras personalizadas para o projeto
    const projectRules: FieldRule[] = [
        // Exemplo: desativa o campo 'confidencialidade' se o projeto não for confidencial
        {
            targetField: 'confidencialidade',
            disableWhen: {
                fields: ['isConfidencial'],
                condition: (values: any) => values.isConfidencial === false || values.isConfidencial === 'false'
            }
        },
        // Outras regras específicas para o projeto
    ];

    // Função para organizar os dados em seções
   // Função para organizar os dados em seções (CORRIGIDA para ficar igual ao edit e list)
    const organizeFormDataIntoSections = (data: FormProps[]) => {
        const projectFields = ['name', 'principalInvestigatorId', 'initialDate', 'finalDate', 'duration'];
        const financialFields = ['financierId', 'accountabilittyDate', 'valor', 'multiplePayments', 'multiplePaymentsRecurrency'];
        const clientFields = ['companyId'];

        const projectData = data.filter(field => projectFields.includes(field.name));
        const financialData = data.filter(field => financialFields.includes(field.name));
        const clientData = data.filter(field => clientFields.includes(field.name));

        return [
            {
                title: "Informações do Projeto",
                icon: "📋",
                color: "project",
                fields: projectData
            },
            {
                title: "Informações Financeiras", 
                icon: "💰",
                color: "financial",
                fields: financialData
            },
            {
                title: "Informações do Cliente",
                icon: "🏢", 
                color: "client",
                fields: clientData
            }
        ];
    };
    
    const fetchSearchers = useCallback(async () => {
        try {
            const response = await fetchSearchersListService();
            return response?.map(({ name, id}: any) => ({ label: name, value: id }));
        } catch (error) {
            console.error("Erro ao buscar pesquisadores:", error);
            return [];
        }
    }, []);

    const fetchFinanciers = useCallback(async () => {
        try {
            const response = await fetchFinanciersService();
            return response?.map(({ name, id}: any) => ({ label: name, value: id }));
        } catch (error) {
            console.error("Erro ao buscar financiadores:", error);
            return [];
        }
    }, []);

    const fetchListCompanies = useCallback(async () => {
        try {
            const response = await getCompanies();
            return response?.map(({ name, id}: any) => ({ label: name, value: id }));
        } catch (error) {
            console.error("Erro ao buscar empresas:", error);
            return [];
        }
    }, []);

    const fetchUserCompany = useCallback(async () => {
        try {
            const userLogged = await storage.getStorage('user');
            if (!userLogged) return null;
            
            const companyId = JSON.parse(userLogged).company.id;
            return await fetchUserCompanyService(companyId);
        } catch (error) {
            console.error("Erro ao buscar empresa do usuário:", error);
            return null;
        }
    }, []);

    const fetchAllData = useCallback(async () => {
        setIsLoading(true);
        try {
            try {
                const user = await storage.getStorage('user');
                if (user) {
                    const userData = JSON.parse(user);
                    if (userData && userData.company && userData.company.id) {
                        setCompanyId(userData.company.id);
                    }
                }
            } catch (error) {
                console.error("Erro ao obter dados do usuário:", error);
            }
            
            const [searchers, financiers, companies, userCompany] = await Promise.all([
                fetchSearchers(),
                fetchFinanciers(),
                fetchListCompanies(),
                fetchUserCompany()
            ]);
            
            setCompany(userCompany || undefined);

            const initialFormData = projectData(
                undefined, 
                [], 
                undefined, 
                searchers, 
                financiers, 
                undefined, 
                undefined, 
                undefined, 
                undefined, 
                companies, 
                userCompany?.name,
                [] // timelineData vazio para criação
            );

            setFormData(initialFormData);
            
            // Organizar dados em seções
            const sections = organizeFormDataIntoSections(initialFormData);
            setFormSections(sections);

        } catch (error) {
            console.error("Erro ao carregar dados do projeto:", error);
            showAlert('Erro ao carregar dados do projeto', SEVERITY.ERROR);
        } finally {
            setIsLoading(false);
        }
    }, [fetchSearchers, fetchFinanciers, fetchListCompanies, fetchUserCompany, showAlert]);

    // Callback para lidar com mudanças de valores nos campos
    const handleFieldValueChange = useCallback((fieldName: string, value: any) => {
        // Aqui você pode adicionar qualquer lógica específica para tratar as mudanças de campo
        
        // Se precisar fazer algo específico com esses valores, pode fazer aqui
        // Exemplo: atualizar cálculos, executar lógica adicional, etc.
    }, []);
    
    const handleCheckboxChange = useCallback((value: boolean, fieldName: string) => {
        console.log('Checkbox changed:', value, fieldName);
        
        if (fieldName === 'multiplePayments') {
            setFormData((prevFormData: FormProps[]) => {
                if (!prevFormData || !prevFormData.length) return prevFormData;
                
                // Primeiro, atualizar o valor do checkbox
                const updatedFormData = prevFormData.map(item => {
                    if (item.name === 'multiplePayments') {
                        return { ...item, value: value };
                    }
                    return item;
                });
                
                // Encontrar o índice do campo multiplePayments
                const checkboxIndex = updatedFormData.findIndex(item => item.name === 'multiplePayments');
                
                let finalFormData;
                
                if (value) {
                    // Adicionar campo - verificar se já existe
                    const fieldExists = updatedFormData.some((item: FormProps) => item.name === 'multiplePaymentsRecurrency');
                    
                    if (!fieldExists && checkboxIndex !== -1) {
                        const newField: FormProps = {
                            typeOfField: FormTypes.INPUT,
                            type: 'number',
                            placeholder: 'Recorrência dos pagamentos (em meses)*',
                            rules: {
                                required: 'Recorrência dos pagamentos é obrigatória',
                                min: {
                                    value: 1,
                                    message: 'A recorrência deve ser pelo menos 1 mês'
                                }
                            },
                            value: null,
                            name: 'multiplePaymentsRecurrency',
                            width: 200,
                            height: 55,
                            disabled: false
                        };
                        
                        // Inserir após o campo multiplePayments
                        const insertIndex = checkboxIndex + 1;
                        
                        finalFormData = [
                            ...updatedFormData.slice(0, insertIndex),
                            newField,
                            ...updatedFormData.slice(insertIndex)
                        ];
                    } else {
                        finalFormData = updatedFormData;
                    }
                } else {
                    // Remover campo se existir
                    finalFormData = updatedFormData.filter(item => item.name !== 'multiplePaymentsRecurrency');
                }
                
                // Reorganizar seções após mudança
                const sections = organizeFormDataIntoSections(finalFormData);
                setFormSections(sections);
                
                return finalFormData;
            });
        }
    }, []);

    const onSubmitForm = async (data: Project) => {
        if (isSubmitting) return;
        
        setIsSubmitting(true);
        setIsLoading(true);
        
        try {            
            data.subProject = null;

            if (company?.name?.toLocaleLowerCase() !== 'causale') {
                data.companyId = companyId;
            }

            await createProjectService(data);

            showAlert('Projeto adicionado com sucesso', SEVERITY.SUCCESS);
            navigate('/dashboard', {replace: true});
            
        } catch (error: any) {
            showAlert(
                error.message || 'Erro ao adicionar projeto', 
                SEVERITY.ERROR
            );
        } finally {
            setIsLoading(false);
            setIsSubmitting(false);
        }
    };
    
    useEffect(() => {
        fetchAllData();
    }, [fetchAllData]);

    return (
        <div className="container-show-project">
            <MenuTop />
            <InfoComponent />
            <div className="container-show-project__container">
                <Form 
                    data={formData}
                    sections={formSections}
                    title='Adicionar projeto' 
                    onSubmitForm={onSubmitForm} 
                    onCancel={() => navigate('/dashboard', {replace: true})}
                    isLoading={isLoading}
                    onFieldValueChange={handleFieldValueChange}
                    onChangeCheckbox={handleCheckboxChange}
                    fieldRules={projectRules}
                />
            </div>
        </div>
    );
}

export default ProjectAdd;